"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = require("../../Typography");
var Warning_1 = __importDefault(require("../../Icons/Utility/components/Warning"));
var styles_1 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    showLabel: true
};
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var Textarea = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className, rows = _a.rows, cols = _a.cols, defaultValue = _a.defaultValue, label = _a.label, _b = _a.showLabel, showLabel = _b === void 0 ? defaultProps.showLabel : _b, disabled = _a.disabled, errorMessage = _a.errorMessage, helperText = _a.helperText, onChange = _a.onChange, tooltip = _a.tooltip, textareaAttributes = __rest(_a, ["id", "name", "className", "rows", "cols", "defaultValue", "label", "showLabel", "disabled", "errorMessage", "helperText", "onChange", "tooltip"]);
    var classes = useStyles();
    var classNames = (0, classnames_1.default)(classes.root, className, disabled && classes.disabled);
    var _c = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''), textareaValue = _c[0], setTextareaValue = _c[1];
    var onInputChange = function (e) {
        e.persist();
        var newVal = e.target.value;
        setTextareaValue(newVal);
        if (onChange) {
            onChange(e);
        }
    };
    var ErrorMessage = function () {
        return (react_1.default.createElement("div", { className: classes.errorHelp },
            react_1.default.createElement(Warning_1.default, { color: "warningAccessible", ariaHidden: true }),
            react_1.default.createElement(Typography_1.UtilityText, { id: "".concat(id, "_err"), size: "xsmall", color: disabled ? 'disabled' : 'secondary', className: classes.errorHelpText }, errorMessage)));
    };
    var HelpMessage = function () {
        return (react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: disabled ? 'disabled' : 'secondary', className: classes.help }, helperText));
    };
    var DisplayMessage = function () {
        if (errorMessage && !disabled)
            return react_1.default.createElement(ErrorMessage, null);
        if (helperText)
            return react_1.default.createElement(HelpMessage, null);
        return null;
    };
    var ariaAttributes = (function () {
        var aria = {};
        if (errorMessage) {
            aria['aria-invalid'] = 'true';
            aria['aria-describedby'] = "".concat(id, "_err");
        }
        if (!showLabel) {
            aria['aria-label'] = label;
        }
        return aria;
    })();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "".concat(id, "_wrap"), className: classNames },
            showLabel && (react_1.default.createElement("span", { className: classes.labelWrapper },
                react_1.default.createElement(Typography_1.LabelText, { id: "".concat(id, "_label"), size: "large", as: "label", htmlFor: id, color: disabled ? 'disabled' : 'primary' }, label),
                tooltip)),
            react_1.default.createElement("div", { className: classes.field },
                react_1.default.createElement("textarea", __assign({ name: name, id: id, className: (0, classnames_1.default)(classes.textarea, errorMessage && !disabled && classes.error), rows: rows, cols: cols, value: textareaValue, disabled: disabled, onChange: onInputChange }, ariaAttributes, textareaAttributes)))),
        react_1.default.createElement(DisplayMessage, null)));
};
exports.default = Textarea;
